import { graphql } from "../gql";

export default graphql(`
  query GetRedirect($input: RedirectSearchInput!) {
    getRedirect(input: $input) {
      fromSlug
      toSlug
      isPermanent
    }
  }
`);
